import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import api, { formatApiError } from "@/lib/api";
import { useConfirm } from "@/components/ConfirmDialog";

const LABELS = { invoices: "facturas", credit_debit_notes: "notas", purchases: "compras", expenses: "gastos", ncf_sequences: "secuencias" };

export function PurgeNonElectronicCard({ onDone }) {
  const [sum, setSum] = useState(null);
  const [busy, setBusy] = useState(false);
  const confirm = useConfirm();
  const load = () => api.get("/admin/non-electronic/summary").then(({ data }) => setSum(data)).catch(() => {});
  useEffect(() => { load(); }, []);
  if (!sum || !Object.values(sum).some((n) => n > 0)) return null;
  const text = Object.entries(sum).filter(([, n]) => n > 0).map(([k, n]) => `${n} ${LABELS[k] || k}`).join(", ");

  const purge = async () => {
    const ok = await confirm({
      title: "¿Eliminar todos los comprobantes B?",
      description: `Se borrarán definitivamente ${text}. Se revierte su inventario, asientos, pagos y recibos. No se puede deshacer.`,
      confirmLabel: "Eliminar",
      destructive: true,
    });
    if (!ok) return;
    setBusy(true);
    try {
      const { data } = await api.post("/admin/non-electronic/purge");
      toast.success(`Eliminados: ${data.invoices} facturas, ${data.credit_debit_notes} notas, ${data.purchases + data.expenses} compras/gastos, ${data.ncf_sequences} secuencias`);
      await load();
      onDone?.();
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mb-4 flex flex-wrap items-center justify-between gap-3 rounded-md border border-amber-300 bg-amber-50 p-3 text-sm" data-testid="purge-b-card">
      <span data-testid="purge-b-summary">Quedan comprobantes no electrónicos (B): <b>{text}</b>.</span>
      <Button size="sm" variant="destructive" onClick={purge} disabled={busy} data-testid="purge-b-btn">
        <Trash2 className="w-4 h-4 mr-1.5" /> {busy ? "Eliminando…" : "Eliminar comprobantes B"}
      </Button>
    </div>
  );
}
